import { Box, Slide, Snackbar, SnackbarContent } from '@mui/material'
import CheckCircle from '@mui/icons-material/CheckCircle';
import { useContext, useEffect, useState } from 'react';
import { UserNotificationsContext } from '../../context/user-notifications/user-notifications';
import { ISharedSnackbarData } from '../../context/user-notifications/user-notifications.model';

export const InfoSnackbar = () => {

  const userNotificationContext = useContext(UserNotificationsContext);

  const [snackbar, setSnackbar] = useState<ISharedSnackbarData>({
    open: false,
    transition: '',
    message: '',
    duration: 5000,
    vertical: 'bottom',
    horizontal: 'left',
    backgroundColor: 'primary.dark'
  });

  useEffect(() => {
    setSnackbar(userNotificationContext.snackbarDetails)
  }, [userNotificationContext.snackbarDetails]);

  const handleClose = (event: any, reason: any) => {
    userNotificationContext.closeSnackbar();
    return;
  }

  return (
    <Snackbar
      open={snackbar.open}
      onClose={handleClose}
      anchorOrigin={{ vertical: snackbar.vertical || 'bottom', horizontal: snackbar.horizontal || 'left' }}
      TransitionComponent={snackbar.transition || Slide}
      key={Slide.name}
      autoHideDuration={snackbar.duration || 5000}
    >
      <SnackbarContent sx={{
        bgcolor: snackbar.backgroundColor,
        fontSize: '16px'
      }}
        message={
          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
            {snackbar.message}
            {snackbar.showSuccessTick && <CheckCircle sx={{ color: '#5cb85c', fontSize: 20 }} />}
          </Box>
        } />
    </Snackbar>
  )
}

